import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

import { OnlineCodeAndLink, OnlineCodeService } from 'src/app/core/services/online-code/online-code.service';
import { fromCarl, selectConfigurationVehicleId } from 'src/app/store/common/common.selectors';

import { NbaParamResolver } from '../nba-param-resolver.interface';

import { NbaParamResolverId } from './nba-param-resolver-id.enum';

@Injectable()
export class MercedesMeResolver implements NbaParamResolver {
  public readonly identifier: string = NbaParamResolverId.MercedesMe;

  public constructor(
    private readonly onlineCodeService: OnlineCodeService,
    private readonly store: Store
  ) {}

  /*
   * this function resolve the mercedesMe Link maintained under mercedesMe.target
   */
  public resolve$(): Observable<string> {
    return combineLatest([
      this.store.select(fromCarl.selectConfig<string>('mercedesMe.target')),
      this.onlineCodeService.getCurrentConfigUrlAndOnlineCode(),
      this.store.select(selectConfigurationVehicleId).pipe(filter(Boolean))
    ]).pipe(
      mergeMap(([target, onlineCodeAndLink, vehicleId]) => this.generateLink(target, onlineCodeAndLink, vehicleId))
    );
  }

  private generateLink(target: string, onlineCodeAndLink: OnlineCodeAndLink, vehicleId: string): Observable<string> {
    let mmeTarget = target;
    mmeTarget = mmeTarget.replace('{onlineCode}', onlineCodeAndLink?.onlineCode || '');
    mmeTarget = mmeTarget.replace('{vehicleId}', encodeURIComponent(vehicleId) || '');
    return of(mmeTarget);
  }
}
